<template>
  <div class="authc-auth account-page">
    <div class="hint-info">
      实名认证决定了账号归属，如企业使用的账号进行个人实名认证，在人员变动交接账号或账号下财产出现纠纷时，可能对个人/企业都带来麻烦，甚至带来经济损失。
    </div>
    <div class="select-box">
      <h4 class="select-title">选择认证类型</h4>
      <el-row :gutter="40">
        <el-col :sm="20" :md="10">
          <router-link :to="{name:'AuthcUser'}" class="select-auth-btn">
            <img class="icon" src="../../assets/icon/user.png" alt="">
            <div class="title">个人实名认证&nbsp;&gt;</div>
            <div class="info">适用于个人用户</div>
          </router-link>
        </el-col>
        <el-col :sm="20" :md="10">
          <router-link :to="{name:'AuthcEnt'}" class="select-auth-btn">
            <img class="icon" src="../../assets/icon/ent.png" alt="">
            <div class="title">企业实名认证&nbsp;&gt;</div>
            <div class="info">适用于企业用户</div>
          </router-link>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Select',
  }
</script>

<style scoped>
.hint-info{
  margin-top: 10px;
  color: #666;
  font-size: 14px;
  padding: 10px 20px;
  background-color: #eee;
}
  .select-auth-btn{
    border: 1px #eee solid;
    display: block;
    box-shadow: 0 0 6px 1px #eee;
    text-align: center;
    padding: 30px 0;
  }
  .select-auth-btn .icon{
    width: 160px;
  }
  .select-auth-btn .title{
    color: #3a8ee6;
    font-size: 18px;
    padding: 10px 0;
  }
  .select-auth-btn .info{
    color: #999;
    font-size: 14px;
  }
  .select-title{
    margin: 20px 0;
    font-size: 16px;
  }
</style>
